module.exports = "../../../../platform/assets/pageMainIcon/default.svg";